import { ContractEntityTooltipIdentifierEnum }        from '@app/modules/contract/components/tooltip/contract-entity-tooltip/contract-entity-tooltip.model';
import { TENANTS_BY_CONTRACT_LIST_OPERATIONS_CONFIG } from '@app/modules/contract/config/tenants-by-contract.config';
import { DeviceTypeEnum }                             from '@appConfig/media-config';
import { ITabContent }                                from '@core/interfaces/common.interfaces';
import {
	IFormBaseData,
	IFormCreateData,
	IFormUpdateData
}                                                     from '@core/interfaces/form.interface';
import { IListOperationsConfig }                      from '@shared/list-operations/model/list-operations.model';

export interface IContractBaseMetadata {
	details: {
		dateFormat: Intl.DateTimeFormatOptions;
		internalTabContent: ITabContent[];
	};

	entityTooltip: {
		allowedCommonIdentifiers: ContractEntityTooltipIdentifierEnum[];
	};

	listOperationsTenantsTab: IListOperationsConfig;

	i18n: {
		page: string;
		entity: string;
		form: string;
		details: string;
		tab: string;
	};

	form: {
		name: string;
		customerIdentifierValidationPattern: RegExp;
		projectNumberValidationPattern: RegExp;
		baseData: IFormBaseData;
		createData: IFormCreateData[];
		updateData: IFormUpdateData[];
		preserveData: IFormUpdateData[];
	};
}

export const CONTRACT_BASE_METADATA: IContractBaseMetadata = {
	details: {
		dateFormat: { month: 'long', year: 'numeric' },
		internalTabContent: [
			{
				key: 'id',
				order: 1,
				i18nPath: 'contract.details.contractId',
				addSpaceToPrevious: false,
				showOnDevices: [ DeviceTypeEnum.MOBILE, DeviceTypeEnum.TABLET, DeviceTypeEnum.DESKTOP ],
				copyClipboard: true
			}
		]
	},
	entityTooltip: {
		allowedCommonIdentifiers: [
			ContractEntityTooltipIdentifierEnum.COMMON_CUSTOMER_IDENTIFIER,
			ContractEntityTooltipIdentifierEnum.COMMON_PROJECT_NUMBER,
			ContractEntityTooltipIdentifierEnum.COMMON_CUSTOMER_NAME,
			ContractEntityTooltipIdentifierEnum.COMMON_STATUS,
			ContractEntityTooltipIdentifierEnum.COMMON_CONTRACT_FROM,
			ContractEntityTooltipIdentifierEnum.COMMON_CONTRACT_TO
		]
	},
	listOperationsTenantsTab: TENANTS_BY_CONTRACT_LIST_OPERATIONS_CONFIG,
	i18n: {
		page: 'page',
		entity: 'entity',
		form: 'form',
		details: 'details',
		tab: 'tab'
	},
	form: {
		name: 'contract',
		customerIdentifierValidationPattern: new RegExp( /^[a-zA-Z0-9]{1,}$/ ),
		projectNumberValidationPattern: new RegExp( /^[0-9A-Z]{2}-[0-9A-Z]{8}-[0-9A-Z]{5}-[0-9A-Z]{2}$/ ),
		baseData: {
			id: {
				hide: true,
				specialTreatments: null,
				order: null,
				i18nPath: '',
				required: false
			},
			customerIdentifier: {
				hide: false,
				specialTreatments: null,
				order: 1,
				i18nPath: 'contract.form.customerIdentifier',
				required: true
			},
			customerName: {
				hide: false,
				specialTreatments: null,
				order: 2,
				i18nPath: 'contract.form.customerName',
				required: true
			},
			projectNumber: {
				hide: false,
				specialTreatments: null,
				order: 3,
				i18nPath: 'contract.form.projectNumber',
				required: true
			},
			from: {
				hide: false,
				specialTreatments: null,
				order: 4,
				i18nPath: 'contract.form.from',
				required: true
			}
		},
		createData: [],
		updateData: [],
		preserveData: [
			{ key: 'contractPropertiesLog.projectNumber', fallbackValue: null },
			{ key: 'customerIdentifier', fallbackValue: null },
			{ key: 'etag', fallbackValue: null },
			{ key: 'id', fallbackValue: null }
		]
	}
};
